<template>
  <div class="wrap">

    <ListTickets
      v-if="!loading"
      :device_id="device_id"
      :filter_asc="filter_asc"
      :filter_type="filter_type"
      :tickets="tickets"
      :show_new_ticket="false"
      @change_filter="change_filter"
      @change_list="change_list"
      @clear_list="clear_list"
    />

    <div v-else style="height: 100%" >
      <div class="spinner">
        <scale-loader />
      </div>
    </div>

  </div>


</template>
<script>

import ListTickets from '../../General/Supports/ListTickets'
import ShowTicket from '../../General/Supports/ShowTicket'

export default {
  name: 'device_tickets',
  components: {
    ListTickets
  },
  props: ['device_id'],

  data () {
    return {
      filter_type: 'status',
      filter_asc: 'asc',
      searched_list: [],
      search: false,
      ticket_list: [],
      loading: true
    }
  },
  created(){
    this.get_device_tickets()
  },
  computed: {
    tickets () {
      let list = this.search ? this.searched_list : this.ticket_list
      list.length ? list.sort(this.compareNumbers): ''

      if (this.$route.params.device_section === 'tickets' && this.$route.params.to_zero){
        for (let ticket of this.ticket_list) {
          if (+ticket.id === +this.$route.params.to_zero) {
            this.show_ticket(ticket.id, true)
          }
        }
      }

      return list

    },
  },
  methods: {
    get_device_tickets(){
      this.$http.v1.getDeviceTickets(this.device_id, (response) => {
        this.ticket_list = response.data
        this.loading = false
      })
    },
    show_ticket(ticket_id, check = false){
      this.$http.v1.getTicketInfo(ticket_id, (response) => {
        let ticket_data = response.data
        let t = this.$createElement(ShowTicket, {
          props: { ticket: ticket_data, check: check }, on: {
            close: () => { this.$modal.hide('dynamic-modal') },
            reload: () => { this.$store.dispatch('ticketList') }
          }
        })
        let temp = {
          render() { return t }
        }
        this.$modal.show(temp, {}, { height: 'auto', name: 'dynamic-modal' })
      })
    },
    compareNumbers(a, b) {
      if (typeof(a[this.filter_type]) == 'string') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] < b[this.filter_type] ? 1 : -1;
        }else{
          return a[this.filter_type] > b[this.filter_type] ? 1 : -1;
        }
      }else if (typeof(a[this.filter_type]) == 'number') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] - b[this.filter_type]
        }else{
          return b[this.filter_type] - a[this.filter_type]
        }
      }
    },
    change_filter(type){
      if (this.filter_type === type) {
        if (this.filter_asc === 'asc') {
          this.filter_asc = 'desc'
        }else{
          this.filter_asc = 'asc'
        }
      }else{
        this.filter_type = type
      }
    },

    change_list(data){
      this.search = true
      this.searched_list = data
    },

    clear_list(){
      this.search = false
      this.searched_list = []
    },
  }
}

</script>
<style>

</style>
